module.exports = __webpack_public_path__ + "img/victrix-cinture-4.30422baf.jpg";